class ScrollingImageText extends window.BAO.CustomElement {
  constructor () {
    super()

    this.observeSections = this.observeSections.bind(this)

    this.observeSections()
  }

  observeSections (sections) {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.7
    }

    const mediaEls = this.els.media.elements

    function observerCallback (entries) {
      entries.forEach(entry => {
        const index = parseInt(entry.target.dataset.index)

        mediaEls.forEach(el => {
          el.setAttribute('aria-hidden', parseInt(el.dataset.index) > index)
        })
      })
    }

    const observer = new IntersectionObserver(observerCallback, observerOptions)

    this.els.content.elements.forEach(sec => observer.observe(sec))
  }
}

if (!customElements.get('scrolling-image-text')) {
  customElements.define('scrolling-image-text', ScrollingImageText)
}
